import { render, staticRenderFns } from "./file-paste.vue?vue&type=template&id=f513d504&scoped=true&"
import script from "./file-paste.vue?vue&type=script&lang=js&"
export * from "./file-paste.vue?vue&type=script&lang=js&"
import style0 from "./file-paste.vue?vue&type=style&index=0&id=f513d504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f513d504",
  null
  
)

export default component.exports